import React from 'react';
import classnames from 'classnames';
import { Card, Typography, Tag, TagProps } from '@guildeducationinc/recess';
import { Application } from '@src/hooks/useApplications';
import { PopoverAction } from './PopoverAction';
import { ButtonAction } from './ButtonAction';
import './ApplicationCard.scss';

interface ApplicationCardProps extends Application {
  status: 'started' | 'completed' | 'approved';
  product?: string;
}

const ApplicationCard: React.FC<ApplicationCardProps> = ({
  program,
  status,
  id: applicationId,
  product = 'home',
  academicPartnerUuid,
  state,
}) => {
  const isStarted = status === 'started';

  const statusLookup = {
    started: { color: 'yellow', text: 'Started' },
    completed: { color: 'grey', text: 'Submitted' },
    approved: { color: 'green', text: 'Approved' },
  };

  const interactionComponent = isStarted ? (
    <ButtonAction product={product} applicationId={applicationId} />
  ) : (
    <PopoverAction
      academicPartnerUuid={academicPartnerUuid || ''}
      applicationId={applicationId}
      product={product}
      programId={program.id}
      status={status}
    />
  );

  const contentCardClassNames = classnames([
    'applicationCardContent',
    'flexContent--center',
    'flex',
    'flexBasis--auto',
    'md:flex--no_wrap',
    isStarted && 'flex--wrap',
  ]);

  return (
    <Card className='applicationCard'>
      <Card.Content className={contentCardClassNames}>
        <div className='applicationCardStatusAndProgram flex--1 md:flex'>
          <div className='applicationCardStatusContainer'>
            {status === 'completed' && state === 'deferred' && (
              <Tag
                color='blue'
                appearance='quiet'
                className='applicationCardStatus margin--right_8'
              >
                <Typography variant='body1'>Early application</Typography>
              </Tag>
            )}
            <Tag
              color={statusLookup[status].color as TagProps['color']}
              appearance='quiet'
              className='applicationCardStatus'
            >
              <Typography variant='body1'>{statusLookup[status].text}</Typography>
            </Tag>
          </div>
          <div className='applicationCardProgram md:flex--1'>
            <Typography variant='body1'>
              {program.studentFacingAcademicPartner?.name ??
                program.studentFacingAcademicPartner?.informalName}
            </Typography>
            <Typography variant='h3' className='programName'>
              {program.name}
            </Typography>
          </div>
        </div>
        {interactionComponent}
      </Card.Content>
    </Card>
  );
};

export default ApplicationCard;
